import React, {Component} from 'react';
import {withRouter, Route} from 'react-router-dom';
import {connect} from 'react-redux';

// styles
import style from '../../Styles/Containers/Modal_Alert.module.css'

//modal
import ModalLargeComponent from '../../Components/modal/ModalLarge'


class ModalLargeContainer extends Component {
    constructor() {
        super();
        this.state = {
            showModal: true,
            showModal2: true
        }
    }

    render() {
        return (
            <div>

            <ModalLargeComponent 
                visible={this.state.showModal}                              //true를 넘기면 팝업이 열리고 false를 넘기면 닫힘
                middleContent={
                    <div className={style.large_middle_content_1}>
                        <div className={style.large_middle_font_large}>3만원 할인</div>
                        <div className={style.large_middle_font_small}>20만원 이상 구매시</div>
                    </div>
                }                          //middle contents
                confirmFont={"허용"}                                      //기본값 "확인" 값을 넘기면 해당 글자가 버튼에 표시
                onConfirm={() => {                                          // 버튼 누를시 이벤트선언
                    this.setState({
                        showModal: false
                    })
                }}
                ></ModalLargeComponent>
            
            <ModalLargeComponent 
                visible={this.state.showModal2}                              //true를 넘기면 팝업이 열리고 false를 넘기면 닫힘
                middleContent={
                    <div className={style.large_middle_content_2}>
                        <img src={""}></img>
                        <div className={style.large_middle_font_normal}>이글립스틱 증정</div>
                    </div>
                }                          //middle contents
                confirmFont={"허용"}                                      //기본값 "확인" 값을 넘기면 해당 글자가 버튼에 표시
                onConfirm={() => {                                          // 버튼 누를시 이벤트선언
                    this.setState({
                        showModal2: false
                    })
                }}
                ></ModalLargeComponent>
            </div>

        )
    }
}

export default connect()(withRouter(ModalLargeContainer))